import React, { useEffect, useMemo, useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import {
  getChangeFareRuleInsight,
  getFlightBookingFromChangeData,
  hasFormattedFareRules,
} from "../../../../data/flight/order/getChangeFareRuleInsight";
import ChangeFareRuleStatusBanner from "../Change/ChangeFareRuleStatusBanner";
import ChangeFareRulesModal from "../Change/ChangeFareRulesModal";

function TicketManagementConfirmationFareRules({
  data,
  showPermissionBanner = false,
}) {
  const flightBooking = useMemo(
    () => getFlightBookingFromChangeData(data),
    [data],
  );
  const [openFareRules, setOpenFareRules] = useState(false);

  const activeFormatted = hasFormattedFareRules(
    flightBooking?.formattedFareRules,
  )
    ? flightBooking.formattedFareRules
    : null;

  const miniRules = flightBooking?.miniRules;
  const hasMiniRules = Boolean(
    (Array.isArray(miniRules) && miniRules.length) ||
    (Array.isArray(miniRules?.rules) && miniRules.rules.length),
  );

  const canOpenChecker = Boolean(
    activeFormatted || flightBooking?.bookingId || flightBooking?._id,
  );

  const insight = useMemo(() => {
    if (!showPermissionBanner) return null;
    if (!activeFormatted && !hasMiniRules) return null;
    return getChangeFareRuleInsight({
      formattedFareRules: activeFormatted,
      miniRules,
    });
  }, [showPermissionBanner, activeFormatted, hasMiniRules, miniRules]);

  useEffect(() => {
    setOpenFareRules(false);
  }, [flightBooking?._id]);

  if (!canOpenChecker && !insight) return null;

  return (
    <div className="flex flex-col gap-3 pt-4">
      {/* {showPermissionBanner && insight ? (
        <ChangeFareRuleStatusBanner insight={insight} />
      ) : null} */}

      {canOpenChecker ? (
        <div className="flex items-center">
          <ChangeFareRulesModal
            data={data}
            open={openFareRules}
            setOpen={setOpenFareRules}
          />
          <button
            type="button"
            className="text-sm text-primary1 flex items-center gap-1 hover:underline"
            onClick={() => setOpenFareRules(true)}
          >
            <AiOutlineInfoCircle className="w-4 h-4" />
            Check fare rules
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default TicketManagementConfirmationFareRules;
